import React from "react";

import { SkeletonBlock, SkeletonLoader } from "@zapier/design-system";

export const SummarySkeleton = () => (
  <SkeletonLoader>
    <SkeletonBlock height="231px" />
  </SkeletonLoader>
);
